<template>
    <div>
     <el-table
      class='riskTable'
      :cell-class-name = "() => 'lu-click'"
      :data="data"
      :height="parentPanelHeight"
      fit
      style="width: 100%;"
      :row-class-name="tableRowClassName"
    >
      <el-table-column label="" sortable prop='title'  align="left" />
      <el-table-column :label="$t('Day PL')" width="150" sortable prop='day' :sort-method='(a,b) => sortFloat(a,b,"day")' align="left">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.day >= 0  ? "positive" : "negative"'>{{ scope.row.day | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Week PL')" width="150" sortable prop='week' :sort-method='(a,b) => sortFloat(a,b,"week")' align="left">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.week >= 0  ? "positive" : "negative"'>{{ scope.row.week | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Month PL')" width="150" sortable prop='month' :sort-method='(a,b) => sortFloat(a,b,"month")' align="left">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.month >= 0  ? "positive" : "negative"'>{{ scope.row.month | formatAmount }}</div>
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
// import { LuHbox, LuVbox, LuItem } from 'lusis-ui'
import utils from '@/utils/formatNumber'
import monitoringMixin from './mixins'

export default {
  name: 'BookPnLReport',
  // components: { LuHbox, LuVbox, LuItem },
  props: [ 'data', 'parentPanel', 'panel' ],
  mixins: [ monitoringMixin ],
  filters: {
    formatAmount: function (value) {
      return utils.formatAmount(value, 2, 3)
    }
  },
  methods: {
    // getDetail: function (brokerName, accountNumber, label) {
    //   let params = [
    //     {'paramName': 'origin', 'paramValue': this.panel.id},
    //     {'paramName': 'platform', 'paramValue': brokerName},
    //     {'paramName': 'accountNumber', 'paramValue': accountNumber},
    //     {'paramName': 'account', 'paramValue': label}
    //   ]
    //   this.$emit('getDetail', {title: 'this.panel.options.title', type: 'account', value: label, params: params, show: true})
    // }
  }
}
</script>

<style scoped>
</style>